unit UrlbAntrag;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer, WebBasis2, Vcl.Menus, WEBLib.Menus   ;

type
  TfrmUrlbAntrag = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    tabUrlbAntrag: TXDataWebDataSet;
    tabUrlbAntragID_URLB_ANTRAG: TIntegerField;
    tabUrlbAntragBEGINN: TStringField;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    tabUrlbAntragINFOTEXT: TStringField;
    tabUrlbAntragSTATUS: TStringField;
    btnIns: TTMSFNCToolBarButton;

    tabUrlbAntragENDE: TStringField;
    tabUrlbAntragID_STATUS: TIntegerField;
    tabUrlbAntragBEENDET: TStringField;
    tabUrlbAntragMITARBEITER: TStringField;
    tabUrlbAntragID_MITARBEITER: TIntegerField;
    btnUrlaubsInfo: TTMSFNCToolBarButton;
    //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure ErzeugeItems; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnInsClick(Sender: TObject); async;
    [async] procedure respGridItemDblClick(Sender: TObject; Index: Integer); async;
    [async] procedure btnUrlaubsInfoClick(Sender: TObject); async;
     //
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);



  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmUrlbAntrag: TfrmUrlbAntrag;

const cForm = 'URLBANTRAG_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul , UrlbAntragEdit, ShowPdf;

//====================================================================================================================//

procedure TfrmUrlbAntrag.btnInsClick(Sender: TObject);
var aResult : TModalResult;
    iNewID : Integer;
begin
  inherited;

  Opt_Speichern;

  iNewID := 0;

  await(  DoUrlbAntragEdit( iNewID  ) );

  iID_Akt := iNewID;

  await( Daten_Laden( iNewID ) );

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabUrlbAntrag.FieldByName('ID_URLB_ANTRAG').AsInteger;
  Daten_Laden(iID);

  //console.Log('1 '+ IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

end;

procedure TfrmUrlbAntrag.btnUrlaubsInfoClick(Sender: TObject);
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    aObj : TParam;
    sDaten, sDatei : String;
    am : TMemoryStream;   iErg : Integer;
begin
  inherited;

  aObj := TParam.Create;
  aObj.Integer1  := StrToIntDef( frmMainForm.BenutzerMaNr,0);
  aObj.Integer2  := CurrentYear;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
   Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetUrlaubsInfoPDF', [ aObj ] ) );
  ClientConn.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);

  sDaten := await(  Crypt( sDaten )  );

  aObj.Free;

  await(  Show_Pdf( sDaten ) );

//  exit;
//
//  sDatei := 'test.pdf';
//  am := TMemoryStream.Create;
//    TTMSFNCUtils.LoadStreamFromBase64( sDaten, am );
//  am.SaveToFile(sDatei);
//  am.Free;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cForm+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cForm+'REC_VON' );
  sBis := TLocalStorage.GetValue( cForm+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.Opt_Speichern;
var sAbf : String;
begin

  TLocalStorage.SetValue( cForm+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cForm+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cForm+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sTauStati, sKopfZeile: String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

    // Urlaubs-Anträge ermitteln
    //
    sSQL := '01:SELECT A.ID_URLB_ANTRAG, A.ID_MITARBEITER, A.BEGINN, A.ENDE, A.ID_STATUS, A.INFOTEXT, BEENDET, '
           +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
           +'  FROM ADRESSE A WHERE M.ID_ADRESSE=A.ID_ADRESSE  ) AS MITARBEITER '
           +'  FROM URLB_ANTRAG A, MITARBEITER M  WHERE A.ID_MITARBEITER=M.ID_MITARBEITER '
           +'  AND A.ID_MITARBEITER='+ frmMainForm.BenutzerMaNr
           + ' ORDER BY A.BEGINN DESC ' +';'  ;

    sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  tabUrlbAntrag.Close;
  tabUrlbAntrag.Open;

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];
          tabUrlbAntrag.Append;
            tabUrlbAntrag.FieldByName('ID_URLB_ANTRAG').AsInteger := SToI(GetFeldWert( sFelder, sDaten, 'ID_URLB_ANTRAG' ));
            tabUrlbAntrag.FieldByName('ID_MITARBEITER').AsInteger := SToI(GetFeldWert( sFelder, sDaten, 'ID_MITARBEITER' ));
            tabUrlbAntrag.FieldByName('ID_STATUS').AsInteger  := SToI(GetFeldWert( sFelder, sDaten, 'ID_STATUS' ));
            tabUrlbAntrag.FieldByName('BEGINN').AsString      := GetFeldWert( sFelder, sDaten, 'BEGINN'  );
            tabUrlbAntrag.FieldByName('ENDE').AsString        := GetFeldWert( sFelder, sDaten, 'ENDE'   );
            tabUrlbAntrag.FieldByName('MITARBEITER').AsString := GetFeldWert( sFelder, sDaten, 'MITARBEITER' );
            tabUrlbAntrag.FieldByName('STATUS').AsString      := Get_UrlbAntragStatus(  tabUrlbAntrag.FieldByName('ID_STATUS').AsInteger );
            tabUrlbAntrag.FieldByName('INFOTEXT').AsString    := GetFeldWert( sFelder, sDaten, 'INFOTEXT' );
            tabUrlbAntrag.FieldByName('BEENDET').AsString     := GetFeldWert( sFelder, sDaten, 'BEENDET' );
          tabUrlbAntrag.Post;
        End;
    End;

  aSL.Free;
  aSL_Daten.Free;

  If aID = 0 then tabUrlbAntrag.First;
  If aID > 0 then
    If not tabUrlbAntrag.Locate('ID_URLB_ANTRAG',aID,[]) then tabUrlbAntrag.First;

  btnNavNext.Enabled := (tabUrlbAntrag.RecordCount=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  ErzeugeItems;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.WebFormCreate(Sender: TObject);
begin

  Inherited;

  bFirst := False;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;


  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;
  btnIns.BitmapContainer := frmMainForm.BitmapCont;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.ErzeugeItems;
var aItem : TResponsiveGridItem;
    sText : String;
begin

  respGrid.Items.Clear;

  tabUrlbAntrag.First;
  While not tabUrlbAntrag.eof Do
    Begin
      sText := '<p><strong>'+tabUrlbAntragBEGINN.AsString+' - ' +tabUrlbAntragENDE.AsString+ '</strong><br />'
       +tabUrlbAntragSTATUS.AsString+'<br />'+tabUrlbAntragINFOTEXT.AsString+'<br /><br /></p>';

      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  tabUrlbAntragID_URLB_ANTRAG.AsInteger;

      //console.log('frmUrlbAntrag  '+ inttostr(self.iID_Akt)+' - '+inttostr(aItem.Tag) );

      If self.iID_Akt > 0 then
      If (tabUrlbAntragID_URLB_ANTRAG.AsInteger = self.iID_Akt) then
        Begin
          //Console.Log('frmUrlbAntrag.iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

     tabUrlbAntrag.Next;

    end;

end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;
    iID_UrlbAntrag : Integer;
begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  iID_UrlbAntrag  := aItem.Tag;

  await( DoUrlbAntragEdit( iID_UrlbAntrag ) );

  await( Daten_Laden( iID_UrlbAntrag ) );


end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmUrlbAntrag.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmUrlbAntrag -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmUrlbAntrag');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmUrlbAntrag: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmUrlbAntrag.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  btnIns := TTMSFNCToolBarButton.Create(Self);
  btnUrlaubsInfo := TTMSFNCToolBarButton.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabUrlbAntrag := TXDataWebDataSet.Create(Self);
  tabUrlbAntragMITARBEITER := TStringField.Create(Self);
  tabUrlbAntragBEGINN := TStringField.Create(Self);
  tabUrlbAntragENDE := TStringField.Create(Self);
  tabUrlbAntragINFOTEXT := TStringField.Create(Self);
  tabUrlbAntragSTATUS := TStringField.Create(Self);
  tabUrlbAntragBEENDET := TStringField.Create(Self);
  tabUrlbAntragID_STATUS := TIntegerField.Create(Self);
  tabUrlbAntragID_MITARBEITER := TIntegerField.Create(Self);
  tabUrlbAntragID_URLB_ANTRAG := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  btnIns.BeforeLoadDFMValues;
  btnUrlaubsInfo.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabUrlbAntrag.BeforeLoadDFMValues;
  tabUrlbAntragMITARBEITER.BeforeLoadDFMValues;
  tabUrlbAntragBEGINN.BeforeLoadDFMValues;
  tabUrlbAntragENDE.BeforeLoadDFMValues;
  tabUrlbAntragINFOTEXT.BeforeLoadDFMValues;
  tabUrlbAntragSTATUS.BeforeLoadDFMValues;
  tabUrlbAntragBEENDET.BeforeLoadDFMValues;
  tabUrlbAntragID_STATUS.BeforeLoadDFMValues;
  tabUrlbAntragID_MITARBEITER.BeforeLoadDFMValues;
  tabUrlbAntragID_URLB_ANTRAG.BeforeLoadDFMValues;
  try
    Width := 1137;
    Height := 515;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1137;
    WebPanel1.Height := 90;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 16;
    lbTau.Top := 8;
    lbTau.Width := 137;
    lbTau.Height := 18;
    lbTau.Caption := 'Urlaubsantr'#228'ge';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 1;
    btnNavPrev.Top := 34;
    btnNavPrev.Width := 60;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 163;
    btnNavNext.Top := 34;
    btnNavNext.Width := 60;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 62;
    btnNavInfo.Top := 34;
    btnNavInfo.Width := 99;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    btnIns.SetParentComponent(WebPanel1);
    btnIns.Name := 'btnIns';
    btnIns.Left := 225;
    btnIns.Top := 34;
    btnIns.Width := 50;
    btnIns.Height := 44;
    btnIns.Cursor := crHandPoint;
    btnIns.ParentDoubleBuffered := False;
    btnIns.DoubleBuffered := True;
    btnIns.Font.Charset := DEFAULT_CHARSET;
    btnIns.Font.Color := clWindowText;
    btnIns.Font.Height := -11;
    btnIns.Font.Name := 'Segoe UI';
    btnIns.Font.Style := [];
    btnIns.ParentColor := True;
    btnIns.TabOrder := 3;
    SetEvent(btnIns, Self, 'OnClick', 'btnInsClick');
    btnIns.Text := '';
    btnIns.Bitmaps.Clear;
    with btnIns.Bitmaps.Add do
    begin
      BitmapName := 'INS';
    end;
    btnIns.BitmapVisible := True;
    btnIns.BitmapContainer := BitmapCont;
    btnIns.ControlIndex := 0;
    btnUrlaubsInfo.SetParentComponent(WebPanel1);
    btnUrlaubsInfo.Name := 'btnUrlaubsInfo';
    btnUrlaubsInfo.Left := 281;
    btnUrlaubsInfo.Top := 34;
    btnUrlaubsInfo.Width := 50;
    btnUrlaubsInfo.Height := 44;
    btnUrlaubsInfo.Cursor := crHandPoint;
    btnUrlaubsInfo.ParentDoubleBuffered := False;
    btnUrlaubsInfo.DoubleBuffered := True;
    btnUrlaubsInfo.Font.Charset := DEFAULT_CHARSET;
    btnUrlaubsInfo.Font.Color := clWindowText;
    btnUrlaubsInfo.Font.Height := -11;
    btnUrlaubsInfo.Font.Name := 'Segoe UI';
    btnUrlaubsInfo.Font.Style := [];
    btnUrlaubsInfo.ParentColor := True;
    btnUrlaubsInfo.TabOrder := 4;
    SetEvent(btnUrlaubsInfo, Self, 'OnClick', 'btnUrlaubsInfoClick');
    btnUrlaubsInfo.Text := '';
    btnUrlaubsInfo.Bitmaps.Clear;
    with btnUrlaubsInfo.Bitmaps.Add do
    begin
      BitmapName := 'INFO';
    end;
    btnUrlaubsInfo.BitmapVisible := True;
    btnUrlaubsInfo.BitmapContainer := BitmapCont;
    btnUrlaubsInfo.ControlIndex := 0;
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 90;
    respGrid.Width := 1137;
    respGrid.Height := 425;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 70;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 260;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 567;
    BitmapCont.Top := 8;
    tabSprachDaten.Left := 96;
    tabSprachDaten.Top := 104;
    tabUrlbAntrag.SetParentComponent(Self);
    tabUrlbAntrag.Name := 'tabUrlbAntrag';
    tabUrlbAntrag.Left := 88;
    tabUrlbAntrag.Top := 192;
    tabUrlbAntragMITARBEITER.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragMITARBEITER.Name := 'tabUrlbAntragMITARBEITER';
    tabUrlbAntragMITARBEITER.FieldName := 'MITARBEITER';
    tabUrlbAntragMITARBEITER.Size := 110;
    tabUrlbAntragBEGINN.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragBEGINN.Name := 'tabUrlbAntragBEGINN';
    tabUrlbAntragBEGINN.Alignment := taCenter;
    tabUrlbAntragBEGINN.DisplayLabel := 'Beginn';
    tabUrlbAntragBEGINN.FieldName := 'BEGINN';
    tabUrlbAntragBEGINN.Size := 10;
    tabUrlbAntragENDE.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragENDE.Name := 'tabUrlbAntragENDE';
    tabUrlbAntragENDE.FieldName := 'ENDE';
    tabUrlbAntragENDE.Size := 10;
    tabUrlbAntragINFOTEXT.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragINFOTEXT.Name := 'tabUrlbAntragINFOTEXT';
    tabUrlbAntragINFOTEXT.DisplayWidth := 100;
    tabUrlbAntragINFOTEXT.FieldName := 'INFOTEXT';
    tabUrlbAntragINFOTEXT.Size := 100;
    tabUrlbAntragSTATUS.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragSTATUS.Name := 'tabUrlbAntragSTATUS';
    tabUrlbAntragSTATUS.FieldName := 'STATUS';
    tabUrlbAntragSTATUS.Size := 50;
    tabUrlbAntragBEENDET.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragBEENDET.Name := 'tabUrlbAntragBEENDET';
    tabUrlbAntragBEENDET.FieldName := 'BEENDET';
    tabUrlbAntragBEENDET.Size := 1;
    tabUrlbAntragID_STATUS.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragID_STATUS.Name := 'tabUrlbAntragID_STATUS';
    tabUrlbAntragID_STATUS.FieldName := 'ID_STATUS';
    tabUrlbAntragID_MITARBEITER.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragID_MITARBEITER.Name := 'tabUrlbAntragID_MITARBEITER';
    tabUrlbAntragID_MITARBEITER.FieldName := 'ID_MITARBEITER';
    tabUrlbAntragID_URLB_ANTRAG.SetParentComponent(tabUrlbAntrag);
    tabUrlbAntragID_URLB_ANTRAG.Name := 'tabUrlbAntragID_URLB_ANTRAG';
    tabUrlbAntragID_URLB_ANTRAG.Alignment := taCenter;
    tabUrlbAntragID_URLB_ANTRAG.DisplayWidth := 6;
    tabUrlbAntragID_URLB_ANTRAG.FieldName := 'ID_URLB_ANTRAG';
    tabUrlbAntragID_URLB_ANTRAG.Required := True;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    btnIns.AfterLoadDFMValues;
    btnUrlaubsInfo.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabUrlbAntrag.AfterLoadDFMValues;
    tabUrlbAntragMITARBEITER.AfterLoadDFMValues;
    tabUrlbAntragBEGINN.AfterLoadDFMValues;
    tabUrlbAntragENDE.AfterLoadDFMValues;
    tabUrlbAntragINFOTEXT.AfterLoadDFMValues;
    tabUrlbAntragSTATUS.AfterLoadDFMValues;
    tabUrlbAntragBEENDET.AfterLoadDFMValues;
    tabUrlbAntragID_STATUS.AfterLoadDFMValues;
    tabUrlbAntragID_MITARBEITER.AfterLoadDFMValues;
    tabUrlbAntragID_URLB_ANTRAG.AfterLoadDFMValues;
  end;
end;

end.

